import { render, staticRenderFns } from "./OperatoreList.vue?vue&type=template&id=032cb404&"
import script from "./OperatoreList.vue?vue&type=script&lang=ts&"
export * from "./OperatoreList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports